import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CallsService } from '@services/api/calls.service';

import { ReportClinicBillingResponse, ReportRequest } from '@interfaces/report';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private calls: CallsService
  ) { }

  getReportData(reportRequest: ReportRequest): Observable<ReportClinicBillingResponse> {
    return this.calls.getReportData(reportRequest).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }
}
